import { theme } from '@garnish/constants';

export const HERO_CARD_HEIGHT_XS = 240;
export const HERO_CARD_HEIGHT_SM = 440;
export const HERO_CARD_HEIGHT_MD = 624;

export const HERO_CARD_BORDER_RADIUS = theme.radius.large;
